import React, {Fragment} from 'react';
import './Mapa.css';

const Mapa = () => {
    return (
        <Fragment>
            <p className="text-left" id="tituloPropiedadesSeccionn">Oficina central en <span>Parada Robles</span></p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3293.098687327994!2d-59.12665702359837!3d-34.37341017303762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bb83f243601411%3A0x7935bc1fbd0226d5!2sAngela%20Sbacco%20Propiedades!5e0!3m2!1sen!2sar!4v1758987749288!5m2!1sen!2sar" width="100%" height="400" ></iframe>
        </Fragment>
    );
}
 
export default Mapa;